import CreditNoteCreate from "./CreditNoteCreate/CreditNoteCreate"
import CreditNoteDetails from "./CreditNoteDetails/CreditNoteDetails"
import CreditNoteEdit from "./CreditNoteEdit/CreditNoteEdit"
import CreditNoteList from "./CreditNoteList/CreditNoteList"
import CreditNotePublicDetails from "./CreditNotePublicDetails/CreditNotePublicDetails"

const List = CreditNoteList
const Create = CreditNoteCreate
const Edit = CreditNoteEdit
const Details = CreditNoteDetails
const PublicDetails = CreditNotePublicDetails

export default {
    List,
    Create,
    Edit,
    Details,
    PublicDetails,
}
